import { useState } from "react";
import { Button, Tooltip } from "@zapier/design-system-beta";
import { Icon } from "@zapier/design-system";

type ShareButtonProps = {
  onClick?: () => void;
};

export const ShareButton = ({ onClick }: ShareButtonProps) => {
  const [tooltipText, setTooltipText] = useState<string>("");

  return (
    <Tooltip content={tooltipText} isOpen={Boolean(tooltipText)}>
      <Button
        iconStart={<Icon name="personGroup" size={16} />}
        onPress={() => {
          navigator.clipboard
            .writeText(window.location.href)
            .then(() => {
              onClick?.();
              setTooltipText("Link copied to clipboard");
              setTimeout(() => setTooltipText(""), 2000);
            })
            .catch((err) => {
              console.error("Failed to copy:", err);
              setTooltipText("Failed to copy");
              setTimeout(() => setTooltipText(""), 2000);
            });
        }}
        variant="secondary"
      >
        Share
      </Button>
    </Tooltip>
  );
};
